import { colors } from "./constants";

export const styles = {
  app: {
    display: "flex",
    height: "100vh",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    backgroundColor: colors.lightGrey,
  },
  sidebar: {
    width: "240px",
    backgroundColor: colors.darkGrey,
    color: colors.white,
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    height: "100vh",
    overflow: "auto",
  },
  logoArea: {
    padding: "20px",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
    textAlign: "center",
  },
  logoText: {
    color: colors.white,
    fontSize: "13px",
    fontWeight: "600",
    marginTop: "8px",
    letterSpacing: "0.3px",
  },
  navSection: { padding: "12px 0" },
  navLabel: {
    color: "rgba(255,255,255,0.35)",
    fontSize: "10px",
    fontWeight: "700",
    letterSpacing: "1.2px",
    textTransform: "uppercase",
    padding: "0 16px 6px",
  },
  navItem: (active) => ({
    display: "flex",
    alignItems: "center",
    padding: "10px 16px",
    margin: "2px 8px",
    borderRadius: "8px",
    cursor: "pointer",
    backgroundColor: active ? colors.softBlue : "transparent",
    color: active ? colors.white : "rgba(255,255,255,0.65)",
    fontSize: "14px",
    fontWeight: active ? "600" : "400",
    transition: "all 0.15s",
  }),
  main: { flex: 1, display: "flex", flexDirection: "column", overflow: "auto" },
  topbar: {
    backgroundColor: colors.white,
    padding: "16px 24px",
    borderBottom: `1px solid ${colors.border}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 1px 3px rgba(15,23,42,0.06)",
  },
  pageTitle: { fontSize: "20px", fontWeight: "700", color: colors.text },
  addButton: {
    backgroundColor: colors.softBlue,
    color: colors.white,
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
  },
  blueButton: {
    backgroundColor: colors.blue,
    color: colors.white,
    border: "none",
    padding: "8px 16px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(37,99,235,0.25)",
  },
  content: { flex: 1, padding: "16px", overflow: "auto" },
  card: {
    backgroundColor: colors.white,
    borderRadius: "12px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    border: `1px solid ${colors.border}`,
    overflow: "hidden",
  },
  tableHeader: {
    backgroundColor: "#f8fafc",
    borderBottom: `2px solid ${colors.border}`,
    color: "#64748b",
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr 1fr",
    gap: "20px",
    padding: "12px 20px",
    fontSize: "11px",
    fontWeight: "700",
    letterSpacing: "0.8px",
    textTransform: "uppercase",
    borderRadius: "12px 12px 0 0",
  },
  tableRow: (hover) => ({
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr",
    gap: "20px",
    padding: "14px 20px",
    borderBottom: `1px solid ${colors.border}`,
    fontSize: "14px",
    color: colors.text,
    backgroundColor: hover ? "#f8fafc" : colors.white,
    cursor: "pointer",
    transition: "background 0.15s",
    alignItems: "center",
  }),
  tierBadge: () => ({
    fontSize: "14px",
    fontWeight: "600",
    color: colors.text,
  }),
  statusBadge: (status) => {
    const map = {
      active: { bg: "#dcfce7", color: "#15803d" },
      archived: { bg: "#f1f5f9", color: "#64748b" },
      passed: { bg: "#dcfce7", color: "#15803d" },
      in_progress: { bg: "#fff7ed", color: "#c2410c" },
      failed: { bg: "#fee2e2", color: "#b91c1c" },
    };
    const theme = map[status] || { bg: "#f1f5f9", color: "#64748b" };
    return {
      display: "inline-block",
      padding: "3px 10px",
      borderRadius: "20px",
      fontSize: "12px",
      fontWeight: "600",
      backgroundColor: theme.bg,
      color: theme.color,
    };
  },
  loading: {
    padding: "40px",
    textAlign: "center",
    color: "#94a3b8",
    fontSize: "14px",
  },
  searchBar: {
    padding: "16px 20px",
    borderBottom: `1px solid ${colors.border}`,
    display: "flex",
    gap: "12px",
    alignItems: "center",
    justifyContent: "space-between",
  },
  searchInput: {
    flex: 1,
    padding: "9px 14px",
    borderRadius: "8px",
    border: `1px solid ${colors.border}`,
    fontSize: "14px",
    outline: "none",
    backgroundColor: "#f8fafc",
  },
  count: {
    padding: "10px 20px",
    fontSize: "13px",
    color: "#94a3b8",
    borderTop: `1px solid ${colors.border}`,
  },
};

export const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  borderRadius: "8px",
  border: `1px solid ${colors.border}`,
  fontSize: "14px",
  outline: "none",
  boxSizing: "border-box",
  backgroundColor: "#f8fafc",
};
export const labelStyle = {
  fontSize: "11px",
  fontWeight: "700",
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  marginBottom: "4px",
  display: "block",
};
export const fieldStyle = { marginBottom: "16px" };
